import { Controller } from "@hotwired/stimulus";
import { isValidEmail } from "../../../../../../plugins/email_validation";

export default class extends Controller {
  static targets = [
    "step",
    "uploadButton",
    "accountInfoForm",
    "fileInput",
    "hiddenFileInput",
    "dropdown",
    "agencyContainer",
    "firstName",
    "lastName",
    "alert",
    "submitButton",
    "agencyId",
    "agencyName"
  ];

  static values = {
    existingfiles: String,
    currentstep: Number,
  };

  connect() {
    this.existingfilesValue = this.existingfilesValue || "[]";
    this.element.addEventListener("keypress", this.preventFormSubmitOnEnter);
    this.currentStep = this.currentstepValue || 0;
    this.updateStepper();
    this.restoreAgencySelection();
  }

  preventFormSubmitOnEnter(event) {
    // Check if the pressed key is "Enter" (key code 13)
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent the default form submission
      console.log("Form submission on Enter prevented.");
    }
  }

  restoreAgencySelection() {
    const agencyId = this.agencyIdTarget.value;
    const dropdown = this.dropdownTarget;

    if (agencyId) {
      this.agencyContainerTarget.classList.remove("hidden");

      let selectedOption = dropdown.querySelector(`option[value="${agencyId}"]`);

      if (!selectedOption) {
        selectedOption = document.createElement("option");
        selectedOption.value = agencyId;
        selectedOption.textContent = dropdown.dataset.agencyName || "Selected Agency";
        selectedOption.selected = true;
        dropdown.appendChild(selectedOption);
      }
    }
  }

  showStep(stepIndex) {
    this.stepTargets.forEach((step, index) => {
      step.classList.toggle("hidden", index !== stepIndex);
      step.classList.toggle("form-step-active", index === stepIndex);
    });

    this.updateStepper();
  }

  updateStepper() {
    document.querySelectorAll(".stepper .step").forEach((step, index) => {
      step.classList.toggle("completed", index < this.currentStep);
      step.classList.toggle("active", index === this.currentStep);
    });
  }

  next() {
    // Check if we are on the file upload step (assuming it's the first step, at index 0)
    if (this.currentStep === 0) {
      const files = this.hiddenFileInputTarget.files;
      if (files.length === 0) {
        // Show error message and stop here
        this.showErrorMessage(
          "Please upload at least one file before proceeding."
        );
        return;
      }
    }

    if (this.currentStep < this.stepTargets.length - 1) {
      this.currentStep++;
      this.showStep(this.currentStep);
      this.hideErrorMessage();
    }
  }

  showErrorMessage(message) {
    const errorMessageElement = document.getElementById("form-error-message");
    if (errorMessageElement) {
      errorMessageElement.textContent = message;
      errorMessageElement.classList.remove("hidden");
      errorMessageElement.classList.add("alert", "alert-danger", "tw-p-4");
      window.scrollTo({
        top: 0,
      });
    }
  }

  hideErrorMessage() {
    const errorMessageElement = document.getElementById("form-error-message");
    if (errorMessageElement) {
      errorMessageElement.textContent = "";
      errorMessageElement.classList.remove("alert", "alert-danger", "tw-p-4");
      errorMessageElement.classList.add("hidden");
    }
  }

  previous() {
    // this.hideErrorMessage();
    if (this.currentStep > 0) {
      this.currentStep--;
      this.showStep(this.currentStep);
    }
  }

  disconnect() {
    this.element.removeEventListener("keypress", this.preventFormSubmitOnEnter);
  }

  async fetchAgencies(event){
    event.preventDefault();
    const email = event.target.value.trim();
    // if (!email) return;
    if (!isValidEmail(email)) return

    try {
      loader.show();
      const response = await fetch(`/dashboard/partners/fetch_agent_by_email?email=${encodeURIComponent(email)}`, {
        method: "GET",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        }
      });

      if (!response.ok) throw new Error("Failed to fetch agencies");
      const data = await response.json();

      if (!data.success) {
        this.showAlert("Account does not exist"); // Show dynamic alert
        this.updateDropdown([]); // Clear dropdown
        return;
      }
      this.hideAlert();
      this.firstNameTarget.value = data.first_name;
      this.lastNameTarget.value = data.last_name;
      this.updateDropdown(data.agencies);
    } catch (error) {
    }
  }

  updateDropdown(agencies) {
    const dropdown = this.dropdownTarget;
    dropdown.innerHTML = '<option value="" disabled hidden>Select Agency</option>';

    if (agencies.length > 0) {
      let agency = agencies[0];
      let option = document.createElement("option");
      option.value = agency.id;
      option.textContent = agency.name;
      option.selected = true;
      option.disabled = true;
      dropdown.appendChild(option);

      this.agencyIdTarget.value = agency.id;
      this.agencyNameTarget.value = agency.name;

      this.agencyContainerTarget.classList.remove("hidden");
      this.submitButtonTarget.disabled = false;
    } else {
      this.submitButtonTarget.disabled = true;
      this.agencyContainerTarget.classList.add("hidden");
    }
    $(dropdown).trigger("change");
    loader.hide();
  }

  showAlert(message) {
    this.alertTarget.innerHTML = `<div class="alert alert-danger" role="alert">${message}</div>`;
  }

  hideAlert() {
    this.alertTarget.innerHTML = ""; // Clear alert box
  }
}
